import React from 'react';

const SwContext = React.createContext<null | {refresh:() => void; needRefresh: boolean;}>(null);

export default SwContext;
